import { JsonObject, JsonProperty } from 'json2typescript'
import SchemeTierEnumConverter from '@/converters/SchemeTierEnumConverter'
import { TierEnum } from '../enums/TierEnum'

@JsonObject('SchemeTier')
export default class SchemeTier {
  @JsonProperty('name', String)
  name = ''

  @JsonProperty('uniqueId', SchemeTierEnumConverter)
  tier = TierEnum.Tier2

  @JsonProperty('order', Number)
  order = 0

  @JsonProperty('isDefault', Boolean)
  isDefault = false
}
